import { Component } from "@angular/core";
import { LucideAngularModule, SearchX } from "lucide-angular";
import { ContainerUifComponent } from "../../../../common/ui-fragments/container-uif/container-uif.component";

@Component({
  selector: "app-notfound-rc",
  imports: [ContainerUifComponent, LucideAngularModule],
  templateUrl: "./notfound-rc.component.html",
  styles: ``,
})
export class NotfoundRcComponent {
  //#region Fields
  icon = SearchX;
  //#endregion
}
